import { createSelector } from 'reselect';
import { stateSelector } from '../state/stateSelector';

export const analyticsDataSelector = createSelector(
  stateSelector,
  state => state?.analytics ?? {},
);
